import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardProfileHeader = _resolveComponent("DashboardProfileHeader")
  const _component_ECShopAdvisory = _resolveComponent("ECShopAdvisory")
  const _component_AccountDetails = _resolveComponent("AccountDetails")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DashboardProfileHeader, {
      user: _ctx.user,
      rankPrimeImage: _ctx.rankPrimeImage,
      rankPrime: _ctx.rankPrime,
      currentRank: _ctx.currentRank,
      showRankImage: _ctx.showRankImage,
      showTabs: false,
      lifetimeAmount: _ctx.lifetimeIncome,
      lifetimeCurrency: _ctx.lifetimeCurrency,
      coverPhoto: _ctx.coverPhoto
    }, null, 8, ["user", "rankPrimeImage", "rankPrime", "currentRank", "showRankImage", "lifetimeAmount", "lifetimeCurrency", "coverPhoto"]),
    _createVNode(_component_ECShopAdvisory),
    _createVNode(_component_AccountDetails),
    _createVNode(_component_router_view)
  ], 64))
}